import React from "react"
import Usage from "./usage.module.scss"
import text from "../styles/typography.module.scss"
import FeatherIcon from "feather-icons-react"
import Img from "gatsby-image"

export default function usage(props) {
  return (
    <div className={`${Usage.section} usage `}>
      <div className={Usage.wrapper}>
        <div className={Usage.textLayout}>
          <div className="iconContainer">
            <FeatherIcon icon={props.feather} />
          </div>
          <h2 className={text.heading1}>{props.title}</h2>
          <p className={text.paragraph}>{props.text}</p>
        </div>
        <div className={Usage.imgcontainer}>
          <Img fluid={props.image} alt={props.alt} />
        </div>
      </div>
    </div>
  )
}
